import React, { useState, useEffect } from "react"
import { Server, CheckCircle2, Webhook, AlertTriangle } from "lucide-react"
import { Card, CardContent } from "../../../components/ui/card"
import { computeDeveloperHealth } from "../../../utils/developerHealthHelpers"

const formatNumber = (n) => new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 2 }).format(n || 0)

const StatCard = ({ label, value, sub, icon: Icon, tracked }) => (
  <Card className="dark:bg-transparent">
    <CardContent className="pt-5 pb-5">
      <div className="flex items-center gap-2 text-muted-foreground mb-2">
        <Icon size={16} />
        <span className="text-sm font-medium">{label}</span>
      </div>
      {tracked === false ? (
        <p className="text-sm text-muted-foreground">Not tracked yet</p>
      ) : (
        <>
          <p className="text-2xl font-bold text-foreground">{value}</p>
          {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
        </>
      )}
    </CardContent>
  </Card>
)

const ApiUsagePanel = ({ organization }) => {
  const orgId = organization?.orgId
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId) return
    computeDeveloperHealth(orgId).then((result) => {
      setData(result)
      setLoading(false)
    })
  }, [orgId])

  if (loading || !data) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:col-span-4">
        {Array.from({ length: 4 })?.map((_, i) => (
          <div key={i} className="h-28 rounded-lg bg-muted animate-pulse" />
        ))}
      </div>
    )
  }

  return (
    <div className="space-y-6 md:col-span-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard label="API Requests" value={formatNumber(data?.apiRequests?.total)} sub="All-time" icon={Server} tracked={data?.apiRequests?.tracked} />
        <StatCard label="Success Rate" value={`${data?.successRate?.value ?? 0}%`} sub="Last 7 days" icon={CheckCircle2} tracked={data?.successRate?.tracked} />
        <StatCard label="Webhooks Delivered" value={data?.webhooksDelivered?.total?.toLocaleString()} sub="All-time" icon={Webhook} tracked={data?.webhooksDelivered?.tracked} />
        <StatCard label="Error Rate" value={`${data?.errorRate?.value ?? 0}%`} sub="Last 7 days" icon={AlertTriangle} tracked={data?.errorRate?.tracked} />
      </div>

      {!data?.apiRequests?.tracked && (
        <Card className="p-8 text-center dark:bg-transparent">
          <p className="text-sm text-muted-foreground">
            No API activity has been logged yet. Usage will appear here once requests start flowing through your organization's API.
          </p>
        </Card>
      )}
    </div>
  )
}

export default ApiUsagePanel